<template>
  <div id="company" class="div-flex-center" v-loading="loading">
    <!-- 企业管理 -->

    <div class="left div-flex-column-center">
      <div
        :class="{
          menu: true,
          'div-flex-center': true,
          'is-active': isActive == item.name,
        }"
        v-show="item.auth == '1'"
        v-for="(item, index) in menus"
        :key="index"
        @click="jump(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right"><router-view /></div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      isActive: "客户管理",
      loading: true,
      menuList: ["/main/company/my_company", "/main/company/user_list"],
      menus: [
        {
          id: "",
          name: "客户管理",
          auth: "2",
          path: "/main/company/my_company",
        },
        {
          id: "",
          name: "用户管理",
          auth: "2",
          path: "/main/company/user_list",
        },
      ],
      userData: {
        userId: "",
        userName: "",
        icon: "",
      },
    };
  },
  methods: {
    /**
     * 路由跳转
     */
    jump(data) {
      sessionStorage.setItem("childernMenu", JSON.stringify(data));
      sessionStorage.setItem("path", data.path);
      this.isActive = data.name;
      this.$router.push({
        path: data.path,
        query: {
          name: data.name,
        },
      });
      this.reload();
    },
  },

  mounted() {
    this.loading = true;
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    this.isActive =
      sessionStorage.getItem("childernMenu") &&
      this.menuList.indexOf(
        JSON.parse(sessionStorage.getItem("childernMenu")).path
      ) >= 0
        ? JSON.parse(sessionStorage.getItem("childernMenu")).name
        : "客户管理";
    let path =
      sessionStorage.getItem("childernMenu") &&
      this.menuList.indexOf(
        JSON.parse(sessionStorage.getItem("childernMenu")).path
      ) >= 0
        ? JSON.parse(sessionStorage.getItem("childernMenu")).path
        : "/main/company/my_company";
    this.$baseData.getUserAuthority(this.userData.userId, this, (data) => {
      this.menus = this.$baseData.judgeDirectoryPermissions(
        data,
        this.menus,
        "企业管理"
      );
    });
    this.$router.push({
      path: path,
      query: {
        name: this.isActive,
      },
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
#company {
  width: 100%;
  height: 100%;
  .left {
    width: 15%;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid @borderColor;
    // border-left: 1px solid @borderColor;

    .menu {
      width: 100%;
      height: 8%;
      border-bottom: 1px solid #33333300;
      border-left: 1px solid #33333300;
      box-sizing: border-box;
      transition: 0.3s;
      &:hover {
        cursor: pointer;
        background-color: rgba(201, 201, 201, 0.212);
        border-left: 5px solid @activeColor;
        color: @activeColor;
      }
    }
    .is-active {
      background-color: rgba(201, 201, 201, 0.212);
      border-left: 5px solid @activeColor;
      color: @activeColor;
    }
  }
  .right {
    width: 0;
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
}
</style>